module.exports = __webpack_public_path__ + "static/img/shl_small_baskeball_level_2.341c48c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_small_baskeball_level_2.png
// module id = gR3g
// module chunks = 5